export const FULL_TIME_HOURS = 40;

export function formatSalary(amount: number, language: string) {
	return new Intl.NumberFormat(language, {
		style: 'currency',
		currency: 'EUR',
		maximumFractionDigits: 0,
	}).format(amount);
}

// Salary for the recorded weekly hours, followed by the full-time amount it is based on.
export function formatSalaryAtFte(
	amount: number,
	fteHours: number | null | undefined,
	language: string,
	withFullTime: (values: { salary: string; hours: number; fullTime: string }) => string,
) {
	const fullTime = formatSalary(amount, language);

	if (fteHours == null || fteHours === FULL_TIME_HOURS) {
		return fullTime;
	}

	return withFullTime({
		salary: formatSalary(Math.round((amount * fteHours) / FULL_TIME_HOURS), language),
		hours: fteHours,
		fullTime,
	});
}
